export default __webpack_public_path__ + "static/media/order.224bbba7.svg";